import React, { useState } from "react";
import ConstellationMap from "../components/ConstellationMap";
import GisRevealModal from "../components/GisRevealModal";
import { getTotalStars, goalStars } from "../utils/stars";

export default function ConstellationPage() {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="max-w-5xl mx-auto px-4 py-6 md:py-10">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-2">Star Quest</h1>
        <p className="text-white/80 mb-6">
          Collect 8 stars from Treblins to reveal the Constellation of Für Elise. 
          {` (${getTotalStars()}/${goalStars()} collected)`}
        </p>

        <ConstellationMap onAllComplete={() => setOpen(true)} />

        <div className="mt-6 text-white/85">
          <p>Tip: Each chapter grants one star. When all eight are lit, Gis will decipher the ancient melody.</p>
        </div>
      </div>

      <GisRevealModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
